import { getRatingProduct, getRatingCollection, getRatingProductDetails } from './fetch-rating';
import { createRating, htmlStarList } from './rating';

const ID_EL_REVIEW_BADGE = 'alireview-review-widget-badge';
const CLASS_EL_REVIEW_BADGE = 'alireview-review-widget-badge';

export const showRatingProduct = async function ({ isAdminLogin = false, num_rand = 0, isGamepage = false }) {
  let elIframeArBox = document.getElementById("shopify-ali-review-widget");

  if (elIframeArBox && window.location.pathname.match(new RegExp('/products/', 'gi'))) {
    /**
     * Add iframe box
     */
    const shopId = elIframeArBox.querySelector(".shop_info") && elIframeArBox.querySelector(".shop_info").getAttribute("shop-id");
    const productId = elIframeArBox.getAttribute("product-id");
    const widgetId = elIframeArBox.querySelector("iframe") && elIframeArBox.querySelector("iframe").getAttribute("widget-id");
    // let isGamepage = document.body.classList.contains(CLASS_GEMPAGE);
    try {
      let result = await getRatingProduct(widgetId, productId);
      if (result.status) {
        const is_duplicate_rating = result.data.hasOwnProperty("issue") && result.data.issue == 'duplicate'
          ? true
          : false;
        const is_hide_no_review = result.data.hasOwnProperty("is_hide_no_review") ? result.data.is_hide_no_review : false;
        const is_transcy_connected = result.data.hasOwnProperty("is_transcy_connected") ? result.data.is_transcy_connected : false;
        const is_show_detail_on_hover = result.data.hasOwnProperty("is_show_detail_on_hover") ? result.data.is_show_detail_on_hover : false;
        var eleRating = renderRatingHtml({ icon_color: result.data.icon_color, icon_content: result.data.icon_content, avg: result.data.avg_star[productId], total: parseInt(result.data.avg_star) === 0 ? "" : result.data.total_review[productId], idTag: ID_EL_REVIEW_BADGE, classTag: '', is_duplicate_rating, is_hide_no_review, is_show_detail_on_hover })
        if (document.getElementsByClassName("alr-display-review-badge").length) {
          let elsRating = document.getElementsByClassName("alr-display-review-badge")
          for (var i = 0; i < elsRating.length; i++) {
            elsRating[i].insertAdjacentHTML('beforeend', eleRating);
          }
        } else if (!isGamepage) {
          let elAlireviewReviewWidgetBadge = document.querySelectorAll('h1[itemprop="name"], h2[itemprop="name"], h3[itemprop="name"], h1[class="product-single__title"], h1[id="ProductHeading"]');
          if (elAlireviewReviewWidgetBadge.length) {
            for (var i = 0; i < elAlireviewReviewWidgetBadge.length; i++) {
              elAlireviewReviewWidgetBadge[i].insertAdjacentHTML('afterend', eleRating);
            }
          }
        }

        // check integrate transcy
        // if(!is_transcy_connected){
        //   let elRating = document.getElementById('alireview-review-widget-badge');
        //   if(elRating){
        //     elRating.classList.add('notranslate')
        //   }
        // }

        addEventScrollBox();
        handleOnboardingScrollBox();
        addEventShowRatingDetail(result.data.icon_color);
      }
    } catch (error) {
      console.log(error)
    }
  }
}

// Support Gempage
export const showRatingProducts = async function (product_ids) {
  try {
    let rs = await getRatingCollection({ product_ids });
    if (rs.status) {
      let result = rs.data;
      const avg_rating = result.hasOwnProperty("avg_star")
        ? result.avg_star
        : {};
      const total_review = result.hasOwnProperty("total_review")
        ? result.total_review
        : {};
      const is_duplicate_rating = result.hasOwnProperty("issue") && result.issue == 'duplicate'
        ? true
        : false;
      const is_hide_no_review = result.hasOwnProperty("is_hide_no_review") ? result.is_hide_no_review : false;
      const is_transcy_connected = result.hasOwnProperty("is_transcy_connected") ? result.is_transcy_connected : false;
      const is_show_detail_on_hover = result.hasOwnProperty("is_show_detail_on_hover") ? result.is_show_detail_on_hover : false;
      // extract key from result.avg_rating
      // const avg_key = Object.keys(avg_rating);
      let listElReviews = document.getElementsByClassName("alr-display-review-badge");
      if (!listElReviews.length) return
      let elIframeArBox = document.getElementById("shopify-ali-review-widget");
      const productIdFromBox = elIframeArBox && elIframeArBox.getAttribute("product-id");
      for (var i = 0; i < listElReviews.length; i++) {
        let attrProductId = listElReviews[i].getAttribute('product-id');
        let avg = avg_rating[attrProductId] != undefined ? avg_rating[attrProductId] : 0
        if (listElReviews[i].childElementCount == 0) {
          if (productIdFromBox == attrProductId) {
            var eleRating = renderRatingHtml({ 
              icon_color: result.icon_color,
              icon_content: result.icon_content,
              avg,
              total: parseInt(avg_rating[attrProductId]) === 0 ? "" : total_review[attrProductId],
              idTag: ID_EL_REVIEW_BADGE,
              classTag: '',
              is_duplicate_rating,
              is_hide_no_review,
              is_show_detail_on_hover
            })
            listElReviews[i].insertAdjacentHTML('beforeend', eleRating);
            addEventScrollBox();
          } else {
            var eleRating = renderRatingHtml({
              icon_color: result.icon_color,
              icon_content: result.icon_content,
              avg,
              total: parseInt(avg_rating[attrProductId]) === 0 ? "" : total_review[attrProductId],
              idTag: '',
              classTag: CLASS_EL_REVIEW_BADGE,
              is_duplicate_rating,
              is_hide_no_review,
              is_show_detail_on_hover
            })
            listElReviews[i].insertAdjacentHTML('beforeend', eleRating);
          }
        }
      }

      // check integrate transcy
      // if(!is_transcy_connected){
      //   let elRating = document.getElementById('alireview-review-widget-badge');
      //   if(elRating){
      //     elRating.classList.add('notranslate')
      //   }
      // }

      handleOnboardingScrollBox();
      addEventShowRatingDetail(result.icon_color);
    }
  } catch (error) {
    console.log(error)
  }
}

function addEventScrollBox() {
  // Badge go to review box

  let elArAlireviewReviewWidgetBadge = document.getElementById(ID_EL_REVIEW_BADGE);
  elArAlireviewReviewWidgetBadge && elArAlireviewReviewWidgetBadge.addEventListener("click", () => {
    if (document.getElementById("shopify-ali-review") && document.getElementById("shopify-ali-review").matches('.un-scroll')) {
      return;
    }
    let iframe = document.querySelector('iframe[widget-id]');
    // console.log('iframe',iframe);
    iframe.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  });

  // var is_visitor = myCookies.is_visitor;
}

export function addEventShowRatingDetail(iconColor) {
  const wrapperRatings = document.querySelectorAll('.alr-wrapper-rating.has-detail'),
    elIframeArBox = document.getElementById("shopify-ali-review-widget"),
    productIdFromBox = elIframeArBox && elIframeArBox.getAttribute("product-id") || '',
    bodyEl = document.querySelector('body');
  let currentEl;

  if (wrapperRatings.length) {
    const isVisibility = function () {
        return bodyEl?.querySelector('[data-alr-rating-detail]');
      },
      callApiFail = function (_this, positionData) {
        if (isVisibility()) {
          renderRatingDetail('fail', bodyEl, positionData);
          const tryAgainEl = bodyEl?.querySelector('[data-alr-try-again]');

          tryAgainEl && tryAgainEl.addEventListener('click', function (e) {
            const mouseoverEvent = new Event('mouseover');

            e.stopPropagation();
            _this.classList.remove('active');
            _this.dispatchEvent(mouseoverEvent);
          });
        }
      };
      
    wrapperRatings.forEach(function (ratingEl) {
      let ratingDetailEl,   
        isBusy = false;

      ratingEl.addEventListener('mouseover', async function () {
        const positionData = {
          top: getOffset(this).top,
          left: getOffset(this).left
        };

        if (isBusy && currentEl === this) {
          renderRatingDetail('loading', bodyEl, positionData);
          return;
        }
        currentEl = this;
        if (!currentEl.className.includes('active')) {
          const productId = currentEl?.closest('[product-id]')?.getAttribute('product-id') || productIdFromBox || '';
  
          isBusy = true;
          currentEl.classList.add('active');
          renderRatingDetail('loading', bodyEl, positionData);
          
          try {
            const res = await getRatingProductDetails(productId);
            
            if (!isVisibility() || currentEl !== this) {
              return;
            }

            if (res.status) {
              renderRatingDetail('success', bodyEl, positionData, res.data, iconColor);
              ratingDetailEl = bodyEl?.querySelector('[data-alr-rating-detail]');

              if (ratingDetailEl) {
                const seeReviewsEl = ratingDetailEl.querySelector('.alr-rating-detail__see-reviews > a');

                  seeReviewsEl?.addEventListener('click', function (e) {
                    const href = this.getAttribute('href');

                    if (decodeURIComponent(window.location.href).includes(href)) {
                      e.preventDefault();
                      currentEl.click();
                    }
                  });

                  setTimeout(function () {
                    const percentEL = ratingDetailEl.querySelectorAll('[data-percent]');
      
                    percentEL.forEach(function (item) {
                      item.setAttribute('style', `width: ${item.dataset.percent}`);
                    });
                  }, 100);
              }

              return;
            }
  
            callApiFail(currentEl, positionData);
          } catch (error) {
            callApiFail(currentEl, positionData);
          } finally {
            isBusy = false;
            !isVisibility() && ratingEl.classList.remove('active');
          }
        }
      });
    });

    bodyEl.addEventListener('mouseover', function (e) {
      const alrRatingDetail = bodyEl.querySelector('[data-alr-rating-detail]'),
        productItem = bodyEl.querySelector('.alr-wrapper-rating.has-detail.active')?.closest('.product-item');

      if (
        !e.target.closest('[data-alr-rating-detail]') &&
        !e.target.closest('.alr-wrapper-rating.has-detail') &&
        !(e.target?.className?.includes && e.target.className.includes('alr-wrapper-rating has-detail'))
      ) {
        alrRatingDetail?.remove();
        bodyEl.querySelector('.has-alr-rating-detail')?.classList.remove('has-alr-rating-detail');
        currentEl?.classList?.remove('active');
      }

      alrRatingDetail && productItem?.classList?.add('has-alr-rating-detail');
    });

    document.addEventListener('scroll', function () {
      bodyEl?.querySelector('[data-alr-rating-detail]')?.remove();
      currentEl?.classList.remove('active');
      bodyEl.querySelector('.has-alr-rating-detail')?.classList.remove('has-alr-rating-detail');
    });
  }
}

function getOffset(element) {
  const rect = element.getBoundingClientRect();
  
  return {
    left: rect.left + window.scrollX + element.offsetWidth / 2,
    top: rect.top + window.scrollY + element.offsetHeight
  };
}

function handleOnboardingScrollBox() {
  // *** ONBOARDING, Auto scroll box review ****
  let onboardingProductUrl = location.href;
  let onboardingPUrlFm = new URL(onboardingProductUrl);
  let messageOnboarding = onboardingPUrlFm.searchParams.get("ar-onboarding");
  if (messageOnboarding) {
    let elShopifyAliReview = document.getElementById("#shopify-ali-review")
    elShopifyAliReview && elShopifyAliReview.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  }
}

function renderRatingHtml({
  icon_color,
  icon_content,
  avg = 0,
  total = '',
  idTag = '',
  classTag = '',
  is_duplicate_rating = false,
  is_hide_no_review = false,
  is_show_detail_on_hover = false
}) {
  if (avg === 0 && is_hide_no_review) {
    return '';
  }
  let style = `
  <style>
    .arv-collection .rating-symbol-foreground > span,
    .arv-collection .alr-rating-symbol-foreground > span,
    .arv-collection .rating-symbol-background,
    .arv-collection .alr-rating-symbol-background,
    #alireview-review-widget-badge .rating-symbol-foreground > span,
    .alireview-review-widget-badge .rating-symbol-foreground > span,
    #alireview-review-widget-badge .rating-symbol-background,
    .alireview-review-widget-badge .rating-symbol-background,
    #alireview-review-widget-badge .alr-rating-symbol-foreground > span,
    .alireview-review-widget-badge .alr-rating-symbol-foreground > span ,
    #alireview-review-widget-badge .alr-rating-symbol-background,
    .alireview-review-widget-badge .alr-rating-symbol-background {
        color :${icon_color}  !important;
    }
    .arv-collection .alr-icon-star:before,
    #alireview-review-widget-badge .alr-icon-star:before,
    .alr-rating-detail[data-alr-rating-detail] .alr-icon-star:before {
      content:"${icon_content}" !important;
    }
  </style>`;
  let createRatingEle = createRating(avg, is_show_detail_on_hover)
  let rating = `
  <div id="${idTag}" class="${classTag}" style="display: none;">
    ${createRatingEle}
    <span style="margin-left: 4px;">${total}</span>
  </div>
  `
  let eleRating = `${style} ${rating} ${is_duplicate_rating ? rating : ''}`;
  return eleRating
}

function renderRatingDetail(status, bodyEl, positionData, data, iconColor) {
  let strHtml = '';

  switch (status) {
    case 'loading':
      strHtml = `
        <div class="alr-rating-detail__loader">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="36" height="36" fill="#F5F5F5"/>
            <path d="M-3373 -459C-3373 -460.105 -3372.1 -461 -3371 -461H580C581.105 -461 582 -460.105 582 -459V2111C582 2112.1 581.105 2113 580 2113H-3371C-3372.1 2113 -3373 2112.1 -3373 2111V-459Z" fill="#E5E5E5"/>
            <g filter="url(#filter0_d_2519_36036)">
            <mask id="path-3-inside-1_2519_36036" fill="white">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.7321 -115C18.9622 -116.333 17.0378 -116.333 16.2679 -115L11.6491 -107H-118C-120.209 -107 -122 -105.209 -122 -103V138C-122 140.209 -120.209 142 -118 142H154C156.209 142 158 140.209 158 138V-103C158 -105.209 156.209 -107 154 -107H24.3509L19.7321 -115Z"/>
            </mask>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.7321 -115C18.9622 -116.333 17.0378 -116.333 16.2679 -115L11.6491 -107H-118C-120.209 -107 -122 -105.209 -122 -103V138C-122 140.209 -120.209 142 -118 142H154C156.209 142 158 140.209 158 138V-103C158 -105.209 156.209 -107 154 -107H24.3509L19.7321 -115Z" fill="white"/>
            <path d="M16.2679 -115L15.4019 -115.5V-115.5L16.2679 -115ZM19.7321 -115L20.5981 -115.5V-115.5L19.7321 -115ZM11.6491 -107V-106H12.2265L12.5152 -106.5L11.6491 -107ZM24.3509 -107L23.4848 -106.5L23.7735 -106H24.3509V-107ZM17.134 -114.5C17.5189 -115.167 18.4811 -115.167 18.866 -114.5L20.5981 -115.5C19.4434 -117.5 16.5566 -117.5 15.4019 -115.5L17.134 -114.5ZM12.5152 -106.5L17.134 -114.5L15.4019 -115.5L10.7831 -107.5L12.5152 -106.5ZM-118 -106H11.6491V-108H-118V-106ZM-121 -103C-121 -104.657 -119.657 -106 -118 -106V-108C-120.761 -108 -123 -105.761 -123 -103H-121ZM-121 138V-103H-123V138H-121ZM-118 141C-119.657 141 -121 139.657 -121 138H-123C-123 140.761 -120.761 143 -118 143V141ZM154 141H-118V143H154V141ZM157 138C157 139.657 155.657 141 154 141V143C156.761 143 159 140.761 159 138H157ZM157 -103V138H159V-103H157ZM154 -106C155.657 -106 157 -104.657 157 -103H159C159 -105.761 156.761 -108 154 -108V-106ZM24.3509 -106H154V-108H24.3509V-106ZM18.866 -114.5L23.4848 -106.5L25.2169 -107.5L20.5981 -115.5L18.866 -114.5Z" fill="#D0D0D0" mask="url(#path-3-inside-1_2519_36036)"/>
            </g>
            <rect width="36" height="36" fill="white"/>
            <path d="M20.4638 33.5561C20.6582 34.7834 19.8193 35.9509 18.5773 35.9907C16.0289 36.0725 13.4831 35.6121 11.1117 34.6298C8.04479 33.3595 5.38891 31.2657 3.43769 28.5801C1.48648 25.8945 0.315941 22.7216 0.055488 19.4123C-0.204965 16.1029 0.454815 12.786 1.96188 9.82817C3.46895 6.87038 5.7646 4.38696 8.59503 2.65248C11.4255 0.91799 14.6804 5.9346e-08 18 0C21.3196 -5.9346e-08 24.5745 0.917989 27.405 2.65248C29.5935 3.99363 31.4624 5.78257 32.8941 7.89234C33.5919 8.92056 33.1406 10.2855 32.0334 10.8496C30.9262 11.4138 29.5852 10.9588 28.8451 9.96052C27.8194 8.57686 26.5341 7.39653 25.0537 6.48936C22.9309 5.18849 20.4897 4.5 18 4.5C15.5103 4.5 13.0691 5.18849 10.9463 6.48936C8.82345 7.79022 7.10171 9.65279 5.97141 11.8711C4.84111 14.0895 4.34628 16.5772 4.54162 19.0592C4.73696 21.5412 5.61486 23.9209 7.07827 25.9351C8.54168 27.9493 10.5336 29.5196 12.8338 30.4724C14.4378 31.1368 16.1482 31.4829 17.8705 31.4994C19.1131 31.5113 20.2695 32.3288 20.4638 33.5561Z" fill="#BABEC3"/>
            <path d="M-3371 -460H580V-462H-3371V-460ZM581 -459V2111H583V-459H581ZM580 2112H-3371V2114H580V2112ZM-3372 2111V-459H-3374V2111H-3372ZM-3371 2112C-3371.55 2112 -3372 2111.55 -3372 2111H-3374C-3374 2112.66 -3372.66 2114 -3371 2114V2112ZM581 2111C581 2111.55 580.552 2112 580 2112V2114C581.657 2114 583 2112.66 583 2111H581ZM580 -460C580.552 -460 581 -459.552 581 -459H583C583 -460.657 581.657 -462 580 -462V-460ZM-3371 -462C-3372.66 -462 -3374 -460.657 -3374 -459H-3372C-3372 -459.552 -3371.55 -460 -3371 -460V-462Z" fill="black" fill-opacity="0.1"/>
            <defs>
            <filter id="filter0_d_2519_36036" x="-126" y="-116" width="288" height="266" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="2"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2519_36036"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2519_36036" result="shape"/>
            </filter>
            </defs>
          </svg>
        </div>`;
    break;
    case 'fail':
      strHtml = `
        <div class="alr-rating-detail__fail">
          <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2602_37634)">
            <path d="M10.7333 28.9854H3.33333C1.49467 28.9854 0 27.4907 0 25.652V4.31869C0 2.48002 1.49467 0.985352 3.33333 0.985352H19.3333C21.172 0.985352 22.6667 2.48002 22.6667 4.31869V13.692C22.6667 14.06 22.368 14.3587 22 14.3587C21.632 14.3587 21.3333 14.0614 21.3333 13.692V4.31869C21.3333 3.21602 20.436 2.31868 19.3333 2.31868H3.33333C2.23067 2.31868 1.33333 3.21602 1.33333 4.31869V25.652C1.33333 26.7547 2.23067 27.652 3.33333 27.652H10.7333C11.1013 27.652 11.4 27.9507 11.4 28.3187C11.4 28.6867 11.1013 28.9854 10.7333 28.9854Z" fill="#6D7175"/>
            <path d="M18 12.9857H4.66667C4.29867 12.9857 4 12.687 4 12.319C4 11.951 4.29867 11.6523 4.66667 11.6523H18C18.368 11.6523 18.6667 11.951 18.6667 12.319C18.6667 12.687 18.368 12.9857 18 12.9857Z" fill="#6D7175"/>
            <path d="M12.6667 18.3187H4.66667C4.29867 18.3187 4 18.02 4 17.652C4 17.284 4.29867 16.9854 4.66667 16.9854H12.6667C13.0347 16.9854 13.3333 17.284 13.3333 17.652C13.3333 18.02 13.0347 18.3187 12.6667 18.3187Z" fill="#6D7175"/>
            <path d="M11.3333 7.65169H4.66667C4.29867 7.65169 4 7.35303 4 6.98503C4 6.61703 4.29867 6.31836 4.66667 6.31836H11.3333C11.7013 6.31836 12 6.61703 12 6.98503C12 7.35303 11.7013 7.65169 11.3333 7.65169Z" fill="#6D7175"/>
            <path d="M30 32.9854H15.3334C14.2307 32.9854 13.3334 32.088 13.3334 30.9854C13.3334 30.5934 13.4414 30.2267 13.6467 29.92L20.964 17.9454C21.3094 17.3574 21.964 16.9854 22.6667 16.9854C23.3694 16.9854 24.024 17.3574 24.3747 17.956L31.7014 29.9454C31.892 30.2267 32 30.5934 32 30.9854C32 32.088 31.1027 32.9854 30 32.9854ZM22.6667 18.3187C22.4347 18.3187 22.2214 18.4387 22.1094 18.6294L14.7694 30.64C14.696 30.7494 14.6667 30.86 14.6667 30.9854C14.6667 31.352 14.9667 31.652 15.3334 31.652H30C30.3667 31.652 30.6667 31.352 30.6667 30.9854C30.6667 30.86 30.6374 30.7494 30.58 30.6654L23.2307 18.64C23.112 18.4387 22.8987 18.3187 22.6667 18.3187Z" fill="#6D7175"/>
            <path d="M22.6667 27.652C22.2987 27.652 22 27.3534 22 26.9854V21.652C22 21.284 22.2987 20.9854 22.6667 20.9854C23.0347 20.9854 23.3333 21.284 23.3333 21.652V26.9854C23.3333 27.3534 23.0347 27.652 22.6667 27.652Z" fill="#6D7175"/>
            <path d="M22.6667 30.3187C23.0349 30.3187 23.3333 30.0202 23.3333 29.652C23.3333 29.2838 23.0349 28.9854 22.6667 28.9854C22.2985 28.9854 22 29.2838 22 29.652C22 30.0202 22.2985 30.3187 22.6667 30.3187Z" fill="#6D7175"/>
            </g>
            <defs>
            <clipPath id="clip0_2602_37634">
            <rect width="32" height="32" fill="white" transform="translate(0 0.985352)"/>
            </clipPath>
            </defs>
          </svg>
          <p>There was an error loading reviews.</p>
          <p data-alr-try-again>Please try again</p>
        </div>`;
    break;
    case 'success':
      const details = data.details || [];
      let style = `
        <style>
          .alr-rating-detail[data-alr-rating-detail] .alr-icon-star {
              color :${iconColor} !important;
          }
          .alr-rating-detail[data-alr-rating-detail] .alr-summary .alr-count-reviews li .alr-progress-bar > div {
            background-color: ${iconColor} !important;
          }
        </style>`;

      strHtml = `
      ${style}
      <div class="alr-rating-detail__header">
        <div class="alr-wrapper-rating alr-rating-star">
          ${htmlStarList(+data?.avg_star || 0)}
          <span class="alr-rating-detail__average">${data.text_overview_review_title || ''}</span>
        </div>
        <p class="alr-rating-detail__total-review">${data.text_total_reviews || ''}</p>
      </div>
      <div class="alr-summary">
        <ul class="alr-count-reviews">
          ${renderRatingBar(details)}
        </ul>
      </div>
      <div class="alr-rating-detail__see-reviews">
        <a href="${data.product_url || ''}" title="${data.text_see_all_reviews || ''}">
          <span data-text-see-review></span>
          <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.0625 0.414062L0.59375 0.859375C0.5 0.976562 0.5 1.16406 0.59375 1.25781L4.83594 5.5L0.59375 9.76562C0.5 9.85938 0.5 10.0469 0.59375 10.1641L1.0625 10.6094C1.17969 10.7266 1.34375 10.7266 1.46094 10.6094L6.38281 5.71094C6.47656 5.59375 6.47656 5.42969 6.38281 5.3125L1.46094 0.414062C1.34375 0.296875 1.17969 0.296875 1.0625 0.414062Z" fill="#757575"/>
          </svg>
        </a>
      </div>`;
    break;
  }

  bodyEl?.querySelector('[data-alr-rating-detail]')?.remove();
  bodyEl?.insertAdjacentHTML('beforeend', 
  `<div class="alr-rating-detail" data-alr-rating-detail style="
    top: ${positionData.top}px;
    left: ${positionData.left}px;
    z-index: 500;"
  >
    <div class="arrow-icon"></div>
    ${strHtml}
  </div>`);

  const alrRatingDetailEl = bodyEl?.querySelector('[data-alr-rating-detail]');

  if (alrRatingDetailEl) {
    const textSeeReviewEl = alrRatingDetailEl.querySelector('[data-text-see-review]');

    (alrRatingDetailEl.offsetLeft - alrRatingDetailEl.offsetWidth / 2) < 0 && alrRatingDetailEl.classList.add('alr-rating-detail--fix-left');
    
    textSeeReviewEl && (textSeeReviewEl.innerText = data.text_see_all_reviews || '');
  }
}

function renderRatingBar(details) {
  return details.map(function ({star, percentage, total}) {
    return `<li star="${star}">
              <div class="alr-sum-wrap">
                  <span class="alr-sum-point">${star}</span>
                  <span class="alr-star"><i class="alr-icon-star"></i></span>
              </div>
              <div class="alr-progress-bar-wrap">
                  <div class="alr-progress-bar">
                      <div data-percent="${percentage || '0%'}"></div>
                  </div>
              </div>
              <span class="alr-count">${total}</span>
          </li>`;
  }).join('');
}